import { LitElement, html, svg } from 'lit';

export class IconLayers24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Tre kvadrater som flyter inn i hverandre</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m1 12 11 5 11-5M12 2 1 7l11 5 11-5-11-5ZM1 17l11 5 11-5"></path></svg>`; }
}
if (!customElements.get('f-icon-layers24', IconLayers24)) {
  customElements.define('f-icon-layers24', IconLayers24);
}